import { HomeScreen } from '@strata/react-page-templates';

import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Home = () => {
    const { data: messages } = useGetHomeScreenMessagesQuery();

    return (
        <HomeScreen
            illustration={HomeScreen.Illustration.HUBBLE}
            button={{ label: 'View Claims', path: AppRoutes.claims }}
            welcomeMessagePartOne="With Free Market Health's Hubble application, you have visibility into submitted claims and their status to ensure they have been successfully received by payers. The automated process tracks and alerts on each claim adjudication step."
            messages={messages}
            viewAllUpdatesUrl={AppRoutes.updatesHistory}
        />
    );
};
